import React, { useEffect, useState, useRef } from "react";
import { Building } from "../../types/building";
import { getBuildingByName } from "../../services/Administracion/buildingsService";

interface BuildingModalProps {
    building: Building;
    onClose: () => void;
    onSave: (building: Building) => void;
}

const BuildingModal: React.FC<BuildingModalProps> = ({ building, onClose, onSave }) => {
    const [buildingName, setBuildingName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(true);
    const [isFormValid, setIsformValid] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ buildingName?: string; buildingDescription?: string }>({});
    const buildingNameInputRef = useRef<HTMLInputElement>(null);
    const descriptionInputRef = useRef<HTMLTextAreaElement>(null);

    const handleSave = () => {
        onSave({ ...building, building_name: buildingName, description, is_active: isActive });
    };

    useEffect(() => {
        if (building.building_id) {
            setBuildingName(building.building_name);
            setDescription(building.description || '');
            setIsActive(building.is_active);
            setErrors({});
        }
        if (!building.building_id && buildingNameInputRef.current) {
            buildingNameInputRef.current.focus();
        } else if (building.building_id && descriptionInputRef.current) {
            descriptionInputRef.current.focus();
        }
    }, [building]);

    useEffect(() => {
        const validarErrores =
            buildingName.trim() !== '' &&
            (!errors.buildingName || errors.buildingName === '') &&
            (!errors.buildingDescription || errors.buildingDescription === '');
        setIsformValid(validarErrores);
    }, [buildingName, isActive, errors]);


    const validateBuildingName = async (buildingName: string) => {
        console.log('Validando nombre del edificio: ', buildingName);
        try {
            const existingBuilding = await getBuildingByName(buildingName);
            if (existingBuilding.building_id) {
                return {
                    isValid: false,
                    errorMessage: `El edificio ${existingBuilding.building_name} YA existe`
                }
            }
            return { isValid: true, errorMessage: '' };
        } catch (error: any) {
            if(error.response.status !== 404){
                return { 
                    isValid: false, 
                    errorMessage: error.message || 'Eror Validando el nombre del edificio'
                }
            }
        }
    };


    const validateField = async (fieldName: string, value: string) => {
        let errorMessage = '';
        if (value.trim() === '') {
            errorMessage = `Este campo es requerido`;
        }
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
        if(fieldName === 'buildingName' && value.trim() !== ''){
            const validation = await validateBuildingName(value);
            if(!validation?.isValid){
                setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: validation?.errorMessage }));
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
            }
        }
    };

    return (
        <div className="modal show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content shadow-lg bg-light">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {building.building_id ? 'Editar' : 'Crear'} Edificio ({building.building_id})</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label htmlFor="buildingName">Nombre del Edificio</label>
                            <input 
                                type="text"
                                className={`form-control ${errors.buildingName ? 'is-invalid' : ''}`}
                                id="buildingName"
                                disabled={!!building.building_id}
                                value={buildingName}
                                ref={buildingNameInputRef}
                                onBlur={e => validateField('buildingName', e.target.value)}
                                onChange={(e) => {
                                    setBuildingName(e.target.value);
                                }}
                            />
                            <div className="invalid-feedback">{errors.buildingName}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor='descripton'>Descripción</label>
                            <textarea
                                className={`form-control ${errors.buildingDescription ? 'is-invalid' : ''}`}
                                id="description"
                                value={description}
                                onChange={(e) => {
                                    setDescription(e.target.value);
                                    validateField('buildingDescription', e.target.value);
                                }}
                                ref={descriptionInputRef}
                            />
                            <div className="invalid-feedback">{errors.buildingDescription}</div>
                        </div>
                        <div className='form-check'>
                            <input
                                type='checkbox'
                                className='form-check-input'
                                id='isActive'
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                            />
                            <label className='form-check-label' htmlFor='isActive'>
                                Activo
                            </label>
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-secondary' onClick={onClose}>
                                Cancelar
                            </button>
                            <button type='button' className='btn btn-primary' onClick={handleSave} disabled={!isFormValid}>
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default BuildingModal;

